import { z } from 'zod'
import { ASSIGNABLE_ROLES } from '../constants/assignableRoles'

export const inviteUserSchema = z.object({
  email: z.string().trim().toLowerCase().email('Correo no válido').max(160),
  role: z.enum(ASSIGNABLE_ROLES, { message: 'Selecciona un rol' }),
})

export const changeRoleSchema = z.object({
  role: z.enum(ASSIGNABLE_ROLES, { message: 'Selecciona un rol' }),
})

export type InviteUserFormValues = z.infer<typeof inviteUserSchema>
export type ChangeRoleFormValues = z.infer<typeof changeRoleSchema>
